import React from 'react';
import clsx from 'clsx';
import { Table } from 'semantic-ui-react';
import MarkdownRender from '../text-editors/MarkdownRender';

const MarkdownCell = ({ value, title, className }) => (
  <Table.Cell className={clsx('aridhia-markdown-cell', className)} title={title}>
    <MarkdownRender value={value} className={className} />
  </Table.Cell>
);

export default MarkdownCell;
